import { MINIMUM_USERS_ON_LEADERBOARD } from './interactive-header.constants';

const getBoardNames = (boards) => {
    const allBoards = Object.keys(boards);
    return allBoards
        .filter(boardName => Object.keys(boards[boardName]).length);
};

const hasNextBoardIndex = (boardIndex, boardNames) => (
    boardIndex < boardNames.length - 1
);

const getNextBoardIndex = (boardNames, currentBoard) => {
    const boardIndex = boardNames.indexOf(currentBoard);
    return hasNextBoardIndex(boardIndex, boardNames) ? boardIndex + 1 : 0;
};

export const getNextBoardName = (boards, currentBoard) => {
    const boardNames = getBoardNames(boards);
    const nextBoardIndex = getNextBoardIndex(boardNames, currentBoard);
    const nextBoardName = boardNames[nextBoardIndex];
    const boardValue = boards[nextBoardName];

    if (!boardValue || !boardValue.length) {
        return null;
    }

    return nextBoardName;
};

function isLeaderBoardReportWithoutMinimumUsers(name, records) {
    return name.endsWith('_leader_board') && records.length < MINIMUM_USERS_ON_LEADERBOARD;
}

function isSavingsReportWithZeroValue(name, records) {
    return name.endsWith('_savings') && records.length && !records[0].total;
}

export const reduceReportsToObject = (reports, fn, init = {}) => reports.reduce(
    (boards, report) => ({ ...boards, [report.name]: fn(report) }),
    init,
);

export const convertReportResultToBoard = ({ name, records }) => {
    const isEmptyReport = isLeaderBoardReportWithoutMinimumUsers(name, records)
        || isSavingsReportWithZeroValue(name, records);

    return !isEmptyReport ? records : [];
};

export const convertReportResultsToBoards = reports => reduceReportsToObject(
    reports,
    convertReportResultToBoard,
);

export const getInitialStateForBoards = (initialState, config) => reduceReportsToObject(
    config.data.reports,
    report => initialState.boards[report.name],
);

export const getLoadingStateForBoards = (state, config, value) => reduceReportsToObject(
    config.data.reports,
    () => value,
    state.loadingState,
);
